import type { TraceContextState } from './types';

export const state: TraceContextState = {
	context: null,
};
